import type { KeyboardEvent } from 'react';

/**
 * A button held while its action runs: `aria-disabled`, with a click handler that returns while it
 * holds. Dimmed and inert to a pointer, as `disabled` is, yet still focusable: a browser takes focus
 * off a button that turns disabled, and in an open dialog it falls to the page under it.
 */
export const HELD_BUTTON_CLASS = 'aria-disabled:pointer-events-none aria-disabled:opacity-50';

/**
 * Takes a held Enter as one press. Enter presses a focused button on every keydown, its auto-repeats
 * included, and a button that keeps focus while its action runs would be pressed again the moment
 * it lets go, say on a refusal that leaves its drawer open. Space presses on release, so a held Space
 * presses once already.
 */
export const ignoreRepeatedEnter = (event: KeyboardEvent<HTMLElement>): void => {
  if (event.repeat && event.key === 'Enter') event.preventDefault();
};
